import { Button, Flex } from "antd";
import { FilterIcon } from "../../assets";
import { Popup } from "../../components";
import FilterForm from "../../forms/FilterForm";
import { usePopup } from "../../hooks/usePopup";
import AppliedFilter from "../../forms/AppliedFilter";
import ExaminerSubmissionTable from "./ExaminerSubmissionTable";
import Select from "../../components/Select";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getAtcState } from "../../redux/store/getState";
import { useEffect } from "react";
import { getAtc } from "../../redux/apiActions/atcActions";
import AtcManager from "../../components/AtcManager";
import { clearAtcFilterValue } from "../../redux/apiSlice/commonSlice";

export default function ExaminerSubmissions() {
  const popup = usePopup();

  const { atc, loading } = useAppSelector(getAtcState);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAtc());
    dispatch(clearAtcFilterValue());
  }, [dispatch]);

  return (
    <>
      <Flex gap="large" wrap="wrap">
        <Popup
          ref={popup.popupRef}
          openTrigger={
            <Button icon={<FilterIcon style={{ marginTop: 2 }} />}>
              Filter
            </Button>
          }
        >
          <FilterForm
            popup={popup}
            extraFormItem={
              <>
                <div
                  className="full-width-divider"
                  style={{ marginBottom: 20 }}
                />
                <Select
                  options={atc}
                  loading={loading.getAtc}
                  formItemProps={{
                    label: "ATC",
                    name: "atc_id",
                    rules: [{ required: true, message: "ATC is required" }],
                  }}
                  placeholder="Select ATC"
                  dropdownRender={<AtcManager />}
                />
              </>
            }
          />
        </Popup>
        <AppliedFilter />
      </Flex>
      <ExaminerSubmissionTable />
    </>
  );
}
